import * as MutationHelpers from 'shared/helpers/vuex/mutationHelpers';
import types from '../mutation-types';
import IframeAppsAPI from '../../api/iframeApps';

export const state = {
  records: [],
  uiFlags: {
    isFetching: false,
    isCreating: false,
    isUpdating: false,
    isDeleting: false,
  },
};

export const getters = {
  getUIFlags(_state) {
    return _state.uiFlags;
  },
  getRecords(_state) {
    return _state.records;
  },
  getEnabledApps(_state) {
    return _state.records.filter(app => app.status === 'enabled');
  },
};

export const actions = {
  get: async function getIframeApps({ commit }) {
    commit(types.SET_IFRAME_APPS_UI_FLAG, { isFetching: true });
    try {
      const response = await IframeAppsAPI.get();
      commit(types.SET_IFRAME_APPS, response.data);
    } catch (error) {
      // Ignore error
    } finally {
      commit(types.SET_IFRAME_APPS_UI_FLAG, { isFetching: false });
    }
  },
  create: async function createApp({ commit }, appObj) {
    commit(types.SET_IFRAME_APPS_UI_FLAG, { isCreating: true });
    try {
      const response = await IframeAppsAPI.create(appObj);
      commit(types.CREATE_IFRAME_APP, response.data);
    } catch (error) {
      const errorMessage = error?.response?.data?.message;
      throw new Error(errorMessage);
    } finally {
      commit(types.SET_IFRAME_APPS_UI_FLAG, { isCreating: false });
    }
  },
  update: async function updateApp({ commit }, { id, ...updateObj }) {
    commit(types.SET_IFRAME_APPS_UI_FLAG, { isUpdating: true });
    try {
      const response = await IframeAppsAPI.update(id, updateObj);
      commit(types.EDIT_IFRAME_APP, response.data);
    } catch (error) {
      throw new Error(error);
    } finally {
      commit(types.SET_IFRAME_APPS_UI_FLAG, { isUpdating: false });
    }
  },
  delete: async function deleteApp({ commit }, id) {
    commit(types.SET_IFRAME_APPS_UI_FLAG, { isDeleting: true });
    try {
      await IframeAppsAPI.delete(id);
      commit(types.DELETE_IFRAME_APP, id);
    } catch (error) {
      throw new Error(error);
    } finally {
      commit(types.SET_IFRAME_APPS_UI_FLAG, { isDeleting: false });
    }
  },
};

export const mutations = {
  [types.SET_IFRAME_APPS_UI_FLAG](_state, data) {
    _state.uiFlags = {
      ..._state.uiFlags,
      ...data,
    };
  },

  [types.SET_IFRAME_APPS]: MutationHelpers.set,
  [types.CREATE_IFRAME_APP]: MutationHelpers.create,
  [types.EDIT_IFRAME_APP]: MutationHelpers.update,
  [types.DELETE_IFRAME_APP]: MutationHelpers.destroy,
};

export default {
  namespaced: true,
  actions,
  state,
  getters,
  mutations,
};
